import { endOfDay, isBefore, isSameDay, parseISO, subDays } from 'date-fns';
/**
 * Unico parser degli istanti: `parseISO` per le stringhe (una date-only è la
 * mezzanotte LOCALE di quel giorno, una stringa non ISO è `Invalid Date`),
 * copia per i `Date`.
 */
export function toInstant(value) {
    return typeof value === 'string' ? parseISO(value) : new Date(value);
}
/** Tolti `days` giorni di calendario, l'istante è già passato rispetto a `now`. */
export function isInstantWithinDays(value, days, now = new Date()) {
    return isBefore(subDays(toInstant(value), days), now);
}
/**
 * L'istante è già passato o cade nello stesso giorno locale di `now`: OGGI
 * conta come scaduto (regola del backoffice).
 */
export function isInstantPastOrToday(value, now = new Date()) {
    const instant = toInstant(value);
    return isBefore(instant, now) || isSameDay(instant, now);
}
/**
 * Il giorno locale dell'istante è finito prima di `now`: scaduto solo dal
 * giorno DOPO, oggi escluso (regola della webapp). Senza data non è scaduto.
 */
export function isDateExpired(value, now = new Date()) {
    return value != null && isBefore(endOfDay(toInstant(value)), now);
}
//# sourceMappingURL=instant.js.map